import React from 'react';
import styles from './Sabotage.module.css';

const Sabotage = () => {
  return (
    <div>
      <section className={styles.heroSection}>
        <img 
          src="/media/banners/SabotageCover.png" 
          alt="Sabotage Banner"
          className={styles.heroBackground}
        />
        <div className={styles.heroContent}>
          <h1>Project: Sabotage</h1>
          <p>A post-apocalyptic survival game where every moment could be your last, and your only true companion is built from the scraps of a forgotten world.</p>
        </div>
        <div className={styles.scrollIndicator}>Scroll to explore</div>
      </section>

      <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionHeading}>About the Game</h2>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard} data-aos="fade-up">
              <h3>Dynamic Living World</h3>
              <p>Experience a truly conscious wasteland where factions wage war, mutated creatures hunt, and every entity lives with its own purpose. Witness unexpected battles, raids, and territorial conflicts in a world that evolves with or without your presence.</p>
            </div>
            <div className={styles.featureCard} data-aos="fade-up">
              <h3>Survival & Migration</h3>
              <p>Survival means never staying still. Establish temporary bases but remember - the longer you linger, the more attention you draw. Master the art of timing your escape before the wasteland converges on your location.</p>
            </div>
            <div className={styles.featureCard} data-aos="fade-up">
              <h3>Mechanical Companions</h3>
              <p>In a world where trust is scarce, your most reliable allies will be the ones you build yourself. Construct unique companions from salvaged technology to aid your survival in the wasteland.<br/>More on this soon...</p>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionHeading}>Development Status</h2>
          <div className={styles.roadmapTimeline}>
            <div className={styles.roadmapItem} data-aos="fade-up">
              <h3>Current Progress</h3>
              <ul>
                <li>Core movement and inventory systems implemented</li>
                <li>Initial combat prototype ready</li>
                <li>Horde mechanics in development</li>
                <li>Companion system under construction</li>
                <li>Initial level design underway</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionHeading}>Development Roadmap</h2>
          <p className={styles.roadmapDisclaimer}>This roadmap is subject to change based on development progress, community feedback, and other factors.</p>
          <div className={styles.roadmapTimeline}>
            <div className={`${styles.roadmapItem} ${styles.completed}`} data-aos="fade-up">
              <div className={styles.phaseBanner}>Completed</div>
              <h3>Phase 1 - Foundations & You</h3>
              <ul>
                <li>Core gameplay mechanics architecture</li>
                <li>Inventory system implementation</li>
                <li>Combat prototype development</li>
                <li>Initial multiplayer framework</li>
              </ul>
            </div>
            <div className={`${styles.roadmapItem} ${styles.next}`} data-aos="fade-up">
              <div className={styles.phaseBanner}>Next Phase</div>
              <h3>Phase 2 - Friends & Foes</h3>
              <ul>
                <li>Combat system enhancement</li>
                <li>Horde mechanics development</li>
                <li>Companion system prototype</li>
                <li>Initial resource gathering</li>
              </ul>
            </div>
            <div className={styles.roadmapItem} data-aos="fade-up">
              <h3>Phase 3 - The Wasteland</h3>
              <ul>
                <li>Weather system implementation</li>
                <li>Interior location design</li>
                <li>Environmental hazards</li>
                <li>Dynamic AI prototype (Hordes)</li>
              </ul>
            </div>
            <div className={styles.roadmapItem} data-aos="fade-up">
              <h3>Phase 4 - Living & the Dead</h3>
              <ul>
                <li>Faction system implementation</li>
                <li>Dynamic AI for factions</li>
                <li>World events system</li>
                <li>AI-driven encounters</li>
              </ul>
            </div>
            <div className={styles.roadmapItem} data-aos="fade-up">
              <h3>Phase 5 - Run Or Die</h3>
              <ul>
                <li>Base building mechanics</li>
                <li>Advanced companion integration</li>
                <li>Resource management system</li>
                <li>Migration mechanics</li>
              </ul>
            </div>
            <div className={styles.roadmapItem} data-aos="fade-up">
              <h3>Phase 6 - Final Development</h3>
              <ul>
                <li>Performance optimization</li>
                <li>Content expansion</li>
                <li>Final testing and balance</li>
                <li>Launch preparation</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sabotage;